import AboutData from './AboutData';
import HowToPurchaseData from './HowToPurchaseData';
import VideoData from './VideoData';
import HowDoesItWork from './HowDoesItWorkData';
import WhoIsThisProductFor from './WhoIsThisProductData';
import HowIsItUsed from './HowIsItUsedData';

export default function TermData() {
  const minAge = 18;
  const maxAge = 90;
  const minCoverageAmount = 25000;
  const maxCoverageAmount = 25000000;

  return {
    name: 'Term Life Insurance',
    subtitle: '',
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    hyperlinks: [
      {
        title: 'ABOUT',
        link: 'about'

      },
      {
        title: 'HOW DOES IT WORK',
        link: 'howDoesItWork',
      },
      {
        title: 'WHO IS THIS PRODUCT FOR',
        link: 'whoIsThisProductFor',
      },
      {
        title: 'HOW TO PURCHASE',
        link: 'howToPurchase',
      }
    ],
    about: AboutData(),
    video: VideoData(),
    howToPurchase: HowToPurchaseData(),
    howDoesItWorkData: HowDoesItWork(),
    WhoIsThisProductData: WhoIsThisProductFor(),
    HowIsItUsedData: HowIsItUsed(),
    insuranceTools: {title: 'Insurance Tools'}
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/TermData.js